import React from "react";
import { useUnit } from "effector-react";
import { useSearchParams } from "react-router-dom";
import { setTotemId, VacuumStore } from "../../stores/VacuumStore/VacuumStore";
import ChooseVacuum from "./pages/ChooseVacuum/ChooseVacuum";
import StartPage from "./pages/StartPage/StartPage";
import ChooseTime from "./pages/ChooseTime/ChooseTime";
import VacuumPayment from "./pages/VacuumPayment/VacuumPayment";
import ChooseTax from "./pages/ChooseTax/ChooseTax";
import { Container, MissingTotemId } from "./TotemVacuumStyles";
import FailedPayment from "./pages/FailedPayment/FailedPayment";
import ProcessingPayment from "./pages/ProcessingPayment/ProcessingPayment";
import SuccessPayment from "./pages/SuccessPayment/SuccessPayment";
import SendReceipt from "./pages/SendReceipt/SendReceipt";
import InactivityTimer from "./components/InactivityTimer/InactivityTimer";
import { PAGES } from "../../stores/VacuumStore/VacumStore.types";
import { setStation } from "../../stores/UserStore/UserStore";
import FailedActivation from "./pages/FailedActivation/FailedActivation";

const pages = [
  StartPage, // 0
  ChooseVacuum, // 1
  ChooseTime, // 2
  VacuumPayment, // 3
  ProcessingPayment, // 4
  ChooseTax, // 5
  SendReceipt, // 6
  SuccessPayment, // 7
  FailedPayment, // 8
  FailedActivation, // 9
];

const TotemVacuum: React.FC = () => {
  const [searchParams] = useSearchParams();
  const totemId = searchParams.get("totemId") ?? "";
  const station = searchParams.get("station") ?? "";

  const { currPage } = useUnit(VacuumStore);

  React.useEffect(() => {
    setTotemId(totemId);
    setStation(station);
  }, [totemId, station]);

  const renderPage = () => {
    const PageComponent = pages[currPage];
    return <PageComponent />;
  };

  const renderTimer = () => {
    if (
      currPage === PAGES.VACUUM_CHOICE ||
      currPage === PAGES.TIME_CHOICE ||
      currPage === PAGES.VACUUM_PAYMENT ||
      currPage === PAGES.SEND_RECEIPT ||
      currPage === PAGES.CHOOSE_TAX
    )
      return <InactivityTimer timeout={300000} />;

    return <></>;
  };

  if (!totemId) {
    return <MissingTotemId>Preencha o totemId</MissingTotemId>;
  }

  return (
    <Container>
      {renderTimer()}
      {renderPage()}
      {/* <ConnectionKeepAlive totemId={totemId} /> */}
    </Container>
  );
};

export default TotemVacuum;
